import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { useFitment } from '../../hooks/hooks';

import { localStorage } from '../../utils/storage/storage';

import { PLP_SLIDER_INITIAL_VALUES } from '../../constants/storage-keys';

export default function useInitialProductListFilterValueLimits(filters) {
  const location = useLocation();
  const { selectedFitment, isLoading: isFitmentLoading } = useFitment();
  const [defaultMaxPrice, setDefaultMaxPrice] = useState(null);
  const [defaultMinPrice, setDefaultMinPrice] = useState(null);
  const [highestPriceInResults, setHighestPriceInResults] = useState(null);
  const [lowestPriceInResults, setLowestPriceInResults] = useState(null);

  const onValueChange = useCallback(([min, max]) => {
    const storedSliderScaleValues = localStorage(PLP_SLIDER_INITIAL_VALUES);

    if (storedSliderScaleValues) {
      storedSliderScaleValues.minVal = min;
      storedSliderScaleValues.maxVal = max;
      localStorage(PLP_SLIDER_INITIAL_VALUES, storedSliderScaleValues);
    }
  }, []);

  useEffect(
    () =>
      function () {
        localStorage(PLP_SLIDER_INITIAL_VALUES, undefined);
      },
    [location.pathname]
  );

  useEffect(() => {
    if (isFitmentLoading) {
      return;
    }

    let storedSliderScaleValues = localStorage(PLP_SLIDER_INITIAL_VALUES);

    const priceRangeFilter = filters?.find(
      filter =>
        filter.categoryName === 'Price Range' ||
        filter.categoryName === 'Package Price'
    );
    const { scaleMinVal, scaleMaxVal } = priceRangeFilter?.values?.[0] || {};

    if (
      !isNaN(scaleMinVal) &&
      !isNaN(scaleMaxVal) &&
      (!storedSliderScaleValues ||
        !storedSliderScaleValues.min ||
        !storedSliderScaleValues.max ||
        scaleMinVal < storedSliderScaleValues.min ||
        scaleMaxVal > storedSliderScaleValues.max)
    ) {
      const highest = !isNaN(storedSliderScaleValues?.max)
        ? Math.max(scaleMaxVal, storedSliderScaleValues?.max)
        : scaleMaxVal;

      const lowest = !isNaN(storedSliderScaleValues?.min)
        ? Math.min(scaleMinVal, storedSliderScaleValues?.min)
        : scaleMinVal;

      storedSliderScaleValues = {
        max: highest,
        maxVal: storedSliderScaleValues?.maxVal || highest,
        min: lowest,
        minVal: storedSliderScaleValues?.minVal || lowest,
        pathname: location.pathname,
        vehicleAssemblyId: selectedFitment?.vehicleAssemblyId
      };
      localStorage(PLP_SLIDER_INITIAL_VALUES, storedSliderScaleValues);
    }

    if (storedSliderScaleValues) {
      setDefaultMinPrice(storedSliderScaleValues.minVal);
      setDefaultMaxPrice(storedSliderScaleValues.maxVal);
      setLowestPriceInResults(storedSliderScaleValues.min);
      setHighestPriceInResults(storedSliderScaleValues.max);
    }
  }, [filters, isFitmentLoading, location.pathname, selectedFitment]);

  return {
    defaultMaxPrice,
    defaultMinPrice,
    highestPriceInResults,
    lowestPriceInResults,
    onValueChange
  };
}
